import { Route } from '@direct-frontend/modules-router';
import { ImportOrdersFromExcelAsync } from '#pages/importOrdersFromExcel';
import { OrdersListAsync } from '#pages/orders';
import { renderWithPermission } from '#shared/lib/managerPermissions';
import { ordersImportExcelRoute, ordersRoute } from '#shared/lib/routes';

export const ordersRoutes = () =>
    renderWithPermission(
        'orders',
        'read',
        <>
            <Route path={ordersRoute.route} element={<OrdersListAsync />} />
            <Route path={ordersImportExcelRoute.route} element={<ImportOrdersFromExcelAsync />} />
        </>
    );
